
export default {
  props: ["description", "barcode", "showPriceHistory"],
  data() {
    return {
      ready: false,
      range: 1,
      width: "",
      height: "",
      max: 0,
      LineChartData: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "Τελική τιμή",
            borderColor: this.$store.getters.store?.eshop?.primary, // This is the color for the line, assuming it's orange from the image
            pointBorderColor: this.getColor("--primary"),
            pointBackgroundColor: this.getColor("--primary"),
            pointHoverBackgroundColor: "#FFFFFF",
            pointHoverBorderColor: this.getColor("--primary"),
            pointStyle: false,
            pointRadius: 0,
            fill: {
              target: "origin",
              above: this.getColor("--primaryAlpha"), // Area will be red above the origin
            },
            stepped: true,
          },
        ],
      },
      LineChartOptions: {
        interaction: {
          intersect: false,
        },
        responsive: true,
        onResize: () => {
          this.height =
            document.querySelector("#chartContainer")?.clientHeight - 100;
          this.width =
            document.querySelector("#chartContainer")?.clientWidth -
            (this.$store.getters.isMobile ? 50 : 300);
        },
        plugins: {
          filler: {
            propagate: true,
          },
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grace: "15%",
            type: "linear",
            ticks: {
              stepSize: 1,
            },
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return "€" + tooltipItem.yLabel;
            },
          },
        },
      },
    };
  },
  watch: {
    showPriceHistory: function (v) {
      if (v) {
        this.fetchHistory();
      }
    },
  },
  methods: {
    getColor(key) {
      try {
        let style = getComputedStyle(document.body);
        return style.getPropertyValue(key);
      } catch (e) {}
    },
    async fetchHistory() {
      try {
        let { days: prices, max } = await this.$axios.$post(
          `items/price-history`,
          {
            barcode: this.barcode,
            months: this.range,
            store_id: this.$store.getters.store.store_id,
          }
        );
        this.max = max * 2;
        this.LineChartData.labels = prices.map((p) => {
          if (!isNaN(p.date)) {
            return this.$$luxon.DateTime.fromMillis(p.date).toFormat("dd LLL");
          } else {
            return this.$$luxon.DateTime.fromSQL(p.date).toFormat("dd LLL");
          }
        });
        this.LineChartData.datasets[0].data = prices.map((p) =>
          parseFloat(p.price)?.toFixed(2)
        );
      } catch (e) {
        console.error(e);
      }

        if (process.browser) {
          this.height =
            document.querySelector("#chartContainer")?.clientHeight - 100;
          this.width =
            document.querySelector("#chartContainer")?.clientWidth -
            (this.$store.getters.isMobile ? 50 : 300);
        }
        this.ready = true;
    },
  },
  unmounted() {
    this.ready = false;
  },
};
